import React from 'react';

import { Button, Notification, type NotificationFlavor } from '@ergeon/core-components';

import FloatingTopSlot from '@shared/ui/FloatingTopSlot';

interface FloatingNotificationBannerProps {
  actionLabel: string;
  children: React.ReactNode;
  notificationKey?: React.Key;
  onAction: () => void;
  onDismiss: () => void;
  flavor?: NotificationFlavor;
  show: boolean;
}

/**
 * Shared shell for the floating top-center action banners (version update,
 * push-notifications prompt). Stays mounted and fades via CSS so dismissal
 * animates out instead of unmounting abruptly.
 */
export default function FloatingNotificationBanner({
  actionLabel,
  children,
  flavor = 'primary',
  notificationKey,
  onAction,
  onDismiss,
  show,
}: FloatingNotificationBannerProps) {
  return (
    <FloatingTopSlot visible={show}>
      <Notification flavor={flavor} key={notificationKey} mode="floating" onClose={onDismiss}>
        <div className="flex lg:flex-row flex-col items-start gap-3">
          <span>{children}</span>
          <Button className="w-full lg:w-fit shrink-0" onClick={onAction} size="small">
            {actionLabel}
          </Button>
        </div>
      </Notification>
    </FloatingTopSlot>
  );
}
